import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setTitle, setMeta, setProperty } from "../lib/seo";

const ROUTES = {
  "/": {
    title: "UniHaul",
    description:
      "UniHaul is the campus marketplace where students buy and sell textbooks, electronics, furniture, room essentials, and more within their college community.",
  },
  "/browse": {
    title: "Browse",
    description:
      "Browse live campus listings on UniHaul — textbooks, electronics, furniture, room essentials, and more from students on your campus.",
  },
  "/home": {
    title: "Browse",
    description:
      "Browse live campus listings on UniHaul — textbooks, electronics, furniture, room essentials, and more from students on your campus.",
  },
  "/login": {
    title: "Login",
    description: "Log in to UniHaul, the campus marketplace for students.",
  },
  "/register": {
    title: "Register",
    description:
      "Create a UniHaul account to buy and sell within your campus community.",
  },
  "/post": {
    title: "Post Item",
    description:
      "Post an item for sale on UniHaul. Add photos, a price, and condition to reach students on your campus.",
  },
  "/dashboard": {
    title: "Dashboard",
    description:
      "Manage your UniHaul listings, orders, and transactions from your dashboard.",
  },
  "/messages": {
    title: "Messages",
    description:
      "Message sellers and buyers on UniHaul to arrange campus transactions.",
  },
  "/settings": {
    title: "Settings",
    description: "Manage your UniHaul account settings.",
  },
  "/cart": {
    title: "Cart",
    description: "Review the items in your UniHaul cart.",
  },
  "/transactions": {
    title: "Transactions",
    description: "Track your UniHaul purchases and sales.",
  },
  "/sellers": {
    title: "Find Sellers",
    description:
      "Find sellers and browse student listings on UniHaul, the campus marketplace.",
  },
  "/users": {
    title: "Seller Profile",
    description: "View a seller profile on UniHaul.",
  },
  "/terms": {
    title: "Terms & Conditions",
    description:
      "UniHaul Terms & Conditions for buying and selling within your campus community.",
  },
  "/privacy": {
    title: "Privacy Policy",
    description:
      "UniHaul Privacy Policy describing how we handle student data.",
  },
};

const APP_NAME = "UniHaul";

function routeFor(pathname) {
  if (ROUTES[pathname]) return { ...ROUTES[pathname], full: pathname };
  const match = Object.entries(ROUTES).find(([path]) =>
    pathname.startsWith(path + "/"),
  );
  if (match) return { ...match[1], full: match[0] };
  return null;
}

function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const route = routeFor(location.pathname);
    const pageTitle =
      route && route.title !== APP_NAME
        ? `${route.title} | ${APP_NAME}`
        : APP_NAME;
    const description =
      route?.description ||
      "UniHaul is the campus marketplace where students buy and sell textbooks, electronics, furniture, and more within their college community.";

    setTitle(pageTitle);
    setMeta("description", description);
    setProperty("og:description", description);
    setProperty("og:url", `https://unihaul.vercel.app${location.pathname}`);
  }, [location.pathname]);

  return null;
}

export default PageTitle;
